/******************************************************************************************
 *	List of available options for Customer Search narrow-down options
 *******************************************************************************************/
(function() {
  

  angular
    .module('rcServices.customersNarrowDownOptions', [])
    .constant('CustomersNarrowDownOptions', [
      {label: 'customersList.searchOptions.customer', filter: 'customer'},
      {label: 'customersList.searchOptions.vipNumber', filter: 'vip'},
      {label: 'customersList.searchOptions.primaryContact', filter: 'contact'},
      {label: 'customersList.searchOptions.salesRep', filter: 'reseller'}
    ]);
})();
